import React, { PropTypes } from 'react';
import Modal from '../../containers/Modal';
import ImageList from '../../containers/ImageList';
import Related from '../../containers/Related';
import ContentBody from '../../containers/ContentBody';
import { formatDate } from '../../ui-helpers';

const Opencall = ({ body, title, subtitle, edition, date, id, images }) => {
  const style = {
    color: edition.background,
  };

  return (
    <div className="fold fold--opencall fold--main fold--main--without-index">
      <div className="fold--main__inner">
        <Modal background={edition.background} />
        <article className="fold__col fold__col--main">
          <div className="content-col">
            <header className="fold__col__header">
              <h1 className="fold__col__title">{ title }</h1>
            </header>
            <div className="content-col__main">
              <div className="fold__col__body">
                {
                  typeof subtitle !== 'undefined' ?
                    <h2 style={style} className="field-sub-title">{ subtitle }</h2> :
                    null
                }
                <div className="field-date" >{ formatDate(date.from) } &mdash; { formatDate(date.to) }</div>
                <ContentBody background={edition.background} body={body} />
              </div>
            </div>
            {
              images.length > 0 ?
              (<div className="content-col__side">
                <div className="fold__col__side">
                  <div className="OpencallInfo">
                    <ImageList images={images} title={title} />
                  </div>
                </div>
              </div>) :
              null
            }
          </div>
          <Related color={edition.background} contentId={id} />
        </article>
      </div>
    </div>
  );
};

Opencall.propTypes = {
  id: PropTypes.string.isRequired,
  date: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
  }).isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.object),
};

Opencall.defaultProps = {
  subtitle: undefined,
  images: [],
};

export default Opencall;



// WEBPACK FOOTER //
// ./js/components/happenings/Opencall.js